/**
   * @ngdoc directive
   * @name adjust.common.directive:timeSpan
   *
   * @description
   * Time span directive for statistics pages
   *
   */
function timeSpan() {
  'ngInject';
  return {
    restrict: 'E',
    controller: 'TimeSpanController',
    controllerAs: 'vm',
    template: require('./time-span.html'),
    scope: {},
    bindToController: {
      loadingState: '=',
      view: '=',
      onSelect: '&',
      instance: '='
    }
  };
}

/**
   * @ngdoc controller
   * @name adjust.common.controller:TimeSpanController
   *
   * @description
   * Controller for the {@link adjust.common.directive:timeSpan timeSpan} directive
   *
   */
function TimeSpanController(TimeSpan, $scope, $document, $element, Helper, CustomPeriod) {
  'ngInject';
  var vm = this;
  var _customRangeSelector = null;

  vm.timeSpans = [];
  vm.params = {};
  vm.tmpParams = {};
  vm.showCustom = false;

  vm.pickTimeSpan = pickTimeSpan;
  vm.openCustom = openCustom;
  vm.closeCustom = closeCustom;
  vm.confirmCustom = confirmCustom;

  $scope.$watch('vm.loadingState', _handleChange);
  $scope.$watch('vm.tmpParams.to', _handleRange);
  $scope.$watch('vm.tmpParams.from', _handleRange);
  $scope.$on('$destroy', _unbindClose);

  /**
   * @ngdoc method
   * @name _handleChange
   * @methodOf adjust.common.controller:TimeSpanController
   *
   * @description
   * Handle loading state change callback
   *
   * @param {boolean} loading loading state
   * @private
   */
  function _handleChange(loading) {

    if (loading) { return; }

    vm.startDate = TimeSpan.getStartDate();
    vm.timeSpans = TimeSpan.getTimeSpans();
    vm.today     = TimeSpan.getToday();

    _prepareParams();

  }

  /**
   * Checks for the outside click to hide the popup
   *
   * @param {Object} e click event
   *
   * @private
   */
  function _handleOutsideClick(e) {

    if (_customRangeSelector && _customRangeSelector.contains(e.target)) {
      return;
    }

    closeCustom();

    $scope.$digest();

  }

  /**
   * @ngdoc method
   * @name _handleRange
   * @methodOf adjust.common.controller:TimeSpanController
   *
   * @description
   * Handle range change
   *
   * @param {string} n new date
   * @param {string} o old date
   * @private
   */
  function _handleRange(n, o) {

    if (n === o) { return; }

    if (vm.view === 'graph' && vm.instance === 'cohorts') {
      vm.maxDate = moment().subtract(1, 'day').format('YYYY-MM-DD');
    } else {
      vm.maxDate = vm.tmpParams.to;
    }
    vm.minDate = vm.tmpParams.from;

  }

  /**
   * @ngdoc method
   * @name _prepareParams
   * @methodOf adjust.common.controller:TimeSpanController
   *
   * @description
   * Prepare params for the view
   *
   * @private
   */
  function _prepareParams() {

    vm.tmpParams = {};
    vm.params = TimeSpan.getParams();

    if (vm.params.range === 'custom') {
      _prepareCustom();
    }

  }

  /**
   * @ngdoc method
   * @name _prepareCustom
   * @methodOf adjust.common.controller:TimeSpanController
   *
   * @description
   * Prepare tmp object for custom date
   *
   * @private
   */
  function _prepareCustom() {

    vm.tmpParams.from = vm.params.from < vm.startDate ? vm.startDate : vm.params.from;
    vm.tmpParams.to = vm.params.to > TimeSpan.getToday() ? TimeSpan.getToday() : vm.params.to;
    vm.tmpParams.range = 'custom';

  }

  /**
   * @ngdoc method
   * @name _preserve
   * @methodOf adjust.common.controller:TimeSpanController
   *
   * @description
   * Preserve time selection and initiate refresh
   *
   * @private
   */
  function _preserve() {

    TimeSpan.preserve(vm.params);

    if (vm.instance === 'cohorts') {
      CustomPeriod.resetCustomPeriod(vm.params);
    }

    vm.onSelect();

    closeCustom();

  }

  /**
   * @ngdoc method
   * @name pickTimeSpan
   * @methodOf adjust.common.controller:TimeSpanController
   *
   * @description
   * Pick the time span from the list
   *
   * @param {Object} span time span object
   */
  function pickTimeSpan(span) {

    vm.tmpParams = {};

    if (span.range === 'custom') {
      openCustom();
    } else {
      vm.params = angular.copy(span);
      _preserve();
    }

  }

  /**
   * Show custom popup and bind events
   */
  function openCustom() {

    if (vm.showCustom) {
      return;
    }

    vm.showCustom = true;

    _prepareCustom();

    Helper.ready(() => {
      _customRangeSelector = $element[0].querySelector('.time-frame-custom');

      _bindClose();
    });

  }

  /**
   * Close custom popup and unbind events
   */
  function closeCustom() {

    vm.showCustom = false;

    _unbindClose();

  }

  /**
   * @ngdoc method
   * @name _handleClose
   * @methodOf adjust.common.controller:TimeSpanController
   *
   * @description
   * Handle ESC popup close
   *
   * @param {Object} e keyup event
   * @private
   */
  function _handleClose(e) {

    if (e.keyCode !== 27) {
      return;
    }

    closeCustom();

    $scope.$digest();

  }

  /**
   * Bind event handlers on $document
   *
   * @private
   */
  function _bindClose() {

    $document.on('keyup', _handleClose);
    $document.on('click', _handleOutsideClick);

  }

  /**
   * Unbind event handlers on $document
   *
   * @private
   */
  function _unbindClose() {

    $document.off('keyup', _handleClose);
    $document.off('click', _handleOutsideClick);

  }

  /**
   * @ngdoc method
   * @name confirmCustom
   * @methodOf adjust.common.controller:TimeSpanController
   *
   * @description
   * Confirm custom selection
   */
  function confirmCustom() {

    vm.params.from = vm.tmpParams.from;
    vm.params.to = vm.tmpParams.to;
    vm.params.range = 'custom';

    _preserve();

  }
}
export { TimeSpanController, timeSpan };
